import React, { useState, useContext } from "react";
import ReactDOM from "react-dom";
import "./Profile.scss";
import "../tak-arz/Details.scss";
import Twittes from "components/common/twitte/Twittes";
import edit from "../../assets/images/Icon feather-edit.png";
import analysis from "../../assets/images/analysis.png";
import business from "../../assets/images/business.png";
import balancingScale from "../../assets/images/balancing-scale.png";
import more from "../../assets/images/Icon awesome-angle-left.png";
import Edit from "./Edit";
import twitteContext from "context/twitteContext";
import { useParams } from "react-router-dom";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
const ProfileDetail = ({ profile, setProfile }) => {
  const [visible, setVisible] = useState(true);
  const params = useParams();
  const auth = useContext(AuthenticationContext);
  const { twittes, setCounter } = useContext(twitteContext);
  const [profileM, setProfileM] = useState({
    profilePic: "",
    fullName: "",
    name: "",
    id: "",
    phone: "",
    email: "",
    about: "",
    accountStatus: "",
  });
  const clickHandler = () => {
    setProfile((profile) => ({
      ...profile,
      fName_lName: profileM.fullName,
      name: profileM.name,
      id: profileM.id,
      email: profileM.email,
      phone: profileM.phone,
      about: profileM.about,
      accountStatus: profileM.accountStatus,
    }));
  };

  const inputHandler = (e) => {
    setProfileM({ ...profileM, [e.target.name]: e.target.value });
  };

  const modalLoader = () => {
    setProfileM({
      profilePic: profile.profilePic,
      fullName: profile.fName_lName,
      name: profile.name,
      id: profile.id,
      phone: profile.phone,
      email: profile.email,
      about: profile.about,
      accountStatus: profile.accountStatus,
    });
  };

  return (
    <>
      <div className="row" style={{ margin: "0px" }}>
        <div className="col-12 col-md-5 col-lg-5 col-xl-5">
          <div className="info scroll">
            <div className="card row">
              <div className="row justify-content-between">
                <div className="d-none d-sm-block d-md-none d-xl-block col-3"></div>
                <div className="ProfileImage col-3 col-md-6">
                  <img src={profile.profilePic} alt="icon" className="icon" />
                </div>
                {}
                {params.id == auth.userInfo.id ? (
                  <div
                    className="col-4 col-md-3"
                    style={{
                      fontSize: "8px",
                      color: "#4E0F8C",
                      cursor: "pointer",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#EditModal"
                    onClick={modalLoader}
                  >
                    <img src={edit} alt="edit" />
                    <br />
                    ویرایش اطلاعات
                  </div>
                ) : (
                  <div className="col-4 col-md-3"></div>
                )}
              </div>

              <div className="col-12 itemP ">{profile.name}</div>
              <div className="col-12 itemP " style={{ marginBottom: "40px" }}>
                {profile.id}@
              </div>

              <div className="col-12 itemP statistics">
                <img src={analysis} alt="analysis" />
                <span className="text"> تعداد پیش بینی </span>
                {profile.countPrediction}
              </div>

              <div className="col-12 itemP statistics">
                <img src={business} alt="business" />
                <span className="text">پیش بینی های موفق </span>
                {profile.successfulPrediction}
              </div>

              <div className="col-12 itemP statistics">
                <img src={balancingScale} alt="balancingScale" />
                <span className="text">بالانس سود و زیان </span>
                {profile.PL}
              </div>
            </div>
          </div>
        </div>
        {/* <div ref={ref}> */}
        <Twittes />
        <div className="col-12 moreT" style={{ textAlign: "-webkit-center" }}>
          {visible ? (
            <button
              type="button"
              class="btn btn-primary"
              onClick={(e) => {
                setCounter(twittes.length);
                setVisible(false);
              }}
            >
              بیشتر
            </button>
          ) : (
            <div
              className="more"
              onClick={(e) => {
                setCounter(3);
                setVisible(true);
              }}
              style={{ marginBottom: "50px" }}
            >
              <img
                src={more}
                alt="more"
                style={{ transform: "rotateX(180deg)" }}
              />
            </div>
          )}
        </div>
        {/* </div> */}
      </div>
      {ReactDOM.createPortal(
        <Edit
          profile={profileM}
          setProfile={setProfileM}
          inputHandler={inputHandler}
          clickHandler={clickHandler}
        />,
        document.getElementById("modals")
      )}
    </>
  );
};
export default ProfileDetail;
